// extracted by mini-css-extract-plugin
export var alertIcon = "_oj-0";